import dayjs from 'dayjs'
import * as Yup from 'yup'

const FormValidationDateInterval = Yup.object().shape({
    periodStart: Yup.mixed()
        .nullable()
        .notRequired()
        .test('is-valid-date', 'Data inválida!', function (value) {
            // Check if the date is a valid Date object
            return value ? dayjs(value).isValid() : true
        })
        .test('is-today-or-before', 'Não é possível selecionar datas futuras!', function (value) {
            return value ? value.isBefore(dayjs()) : true
        }),
    periodEnd: Yup.mixed()
        .nullable()
        .notRequired()
        .test('is-valid-date', 'Data inválida!', function (value) {
            // Check if the date is a valid Date object
            return value ? dayjs(value).isValid() : true
        })
        .test('is-after-first-date', 'Início do período deve ser antes do fim do período!', function (periodEnd) {
            const periodStart = this.parent.periodStart // Access the periodStart from the parent object
            return periodEnd && periodStart ? new Date(periodEnd) >= new Date(periodStart) : true
        })
        .test('is-today-or-before', 'Não é possível selecionar datas futuras!', function (value) {
            return value ? value.isBefore(dayjs()) : true
        }),
})

export default FormValidationDateInterval
